/**
 * PRODUCT branding fallback logo (Mafert), not company identity.
 * Company logos come from Redux `branding` via utils/companyBranding.js.
 * See docs/company-settings-branding-contract.md.
 */
export const defaultProductLogoSrc = require('../assets/img/logo-mafert.png');

/** Unified max height (rem) for print-style header rows (maintenance, training, etc.). */
export const PRINT_HEADER_LOGO_REM = 5;

export const printHeaderLogoStyle = {
  height: `${PRINT_HEADER_LOGO_REM}rem`,
  width: 'auto',
};
